import { Grid } from "@mui/material";
import { useOpen, useBlobUrl } from "../../../../../../../libs/hooks";
import { useWorkflowCheckpointStore } from "../../../../../store";
import { OnlyPhoto } from "../../../shared-component";

export const Documentos = () => {
  const inspectionContainerPhoto = useWorkflowCheckpointStore(
    (state) => state.inspectionContainerPhoto
  );

  const setInspectionContainerPhoto = useWorkflowCheckpointStore(
    (state) => state.setInspectionContainerPhoto
  );

  const {
    open: openIP,
    handleClose: handleCloseIP,
    handleOpen: handleOpenIP,
  } = useOpen();
  const fotoUrl = useBlobUrl(inspectionContainerPhoto);

  return (
    <Grid
      container
      justifyContent="center"
      alignContent="flex-start"
      alignItems="flex-start"
      spacing={0}
      sx={{bgcolor:"white"}}
    >
      <Grid item xs={12} sx={{ m: 1, display:"flex", justifyContent:"center" }}>
        <OnlyPhoto
          foto={fotoUrl}
          label="INSPECCIÓN CONTENEDOR"
          handleClose={handleCloseIP}
          handleOpen={handleOpenIP}
          open={openIP}
          setFoto={setInspectionContainerPhoto}
        />
      </Grid>
    </Grid>
  );
};
